import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CvSearchComponent } from './cv-search.component';
import { AuthGuard } from 'src/app/gaurd/auth.guard';
import { AuthEmployerGuard } from 'src/app/gaurd/auth-employer.guard';

const routes: Routes = [
  {
    path: '',
    component: CvSearchComponent,
    data: {
      title: 'CV SEARCH',
    },
    canActivate: [AuthEmployerGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CvSearchRoutingModule {}
